export const docsNavigation = [
  { id: "quickstart", group: "开始使用", title: "快速开始", summary: "一个地址，一把密钥。先完成第一次调用。" },
  { id: "responses", group: "接口指南", title: "Responses API", summary: "输入、输出、流式响应与客户端工具调用。" },
  { id: "tools", group: "接口指南", title: "内置工具", summary: "在一次请求中完成搜索、图片生成或编辑。" },
  { id: "codex", group: "客户端接入", title: "接入 Codex", summary: "使用 LumaNova API Key，在 Codex 中连接 DeepSeek。" },
  { id: "usage", group: "参考", title: "用量与排错", summary: "查看额度、理解结算，以及安全处理重试。" },
];

export const basicPayload = { model: "deepseek-flash", input: "用三句话介绍你能帮助我完成什么。", store: false, stream: false };
export const chatPayload = { model: "deepseek-flash", messages: [{ role: "user", content: "你好，请用一句话介绍自己。" }], stream: false };
export const codexConfig = `# 根级配置：放在任何 [table] 之前；已有同名项请修改，不要重复追加。
model = "deepseek-flash"
model_provider = "lumanova"
preferred_auth_method = "apikey"
forced_login_method = "api"
model_reasoning_effort = "high"
web_search = "disabled"
show_raw_agent_reasoning = true
model_catalog_json = "~/.codex/models.json"

[model_providers.lumanova]
name = "lumanova"
base_url = "https://api.lumanova.icu/v1"
wire_api = "responses"
experimental_bearer_token = "<你的 LumaNova API Key>"`;

export const desktopConfig = `[desktop]
enabled-reasoning-efforts = ["low", "medium", "high", "xhigh", "ultra", "max"]`;

export const sdkExample = `import os
from openai import OpenAI

client = OpenAI(
    api_key=os.environ["LUMA_API_KEY"],
    base_url="https://api.lumanova.icu/v1",
    timeout=3600,
    max_retries=0,
)
response = client.responses.create(
    model="deepseek-flash",
    input="用三句话介绍你能帮助我完成什么。",
    store=False,
)
print(response.output_text)
client.close()`;

export const streamExample = `# 使用上面的 client；在 client.close() 之前执行。
with client.responses.stream(
    model="deepseek-flash",
    input="搜索 Python asyncio 的官方文档并概括用途。",
    tools=[{"type": "web_search"}],
    store=False,
) as stream:
    for event in stream:
        if event.type == "response.output_text.delta":
            print(event.delta, end="", flush=True)
    response = stream.get_final_response()
print(response.status)
print(response.model_dump().get("billing"))`;

export const curlRequest = (payload, endpoint = "responses") => `curl --no-buffer --show-error \\
  "https://api.lumanova.icu/v1/${endpoint}" \\
  -H "Authorization: Bearer $LUMA_API_KEY" \\
  -H "Content-Type: application/json" \\
  -d '${JSON.stringify(payload, null, 2)}'`;

export const docErrorRows = [
  ["400", "请求参数或能力不支持", "查看 error.message；托管工具不要与 function / custom / MCP 混用。"],
  ["401", "密钥未通过验证", "检查是否填写 LumaNova Key，以及密钥是否已被删除。"],
  ["409", "同一幂等键已经提交", "保留原 request_id；不要更换键自动重跑。当前不重放旧结果。"],
  ["429", "额度不足或并发受限", "查看 error.code，再到网页的用量与订阅中核对。"],
  ["503 / billing_pending", "结算状态待确认", "保留 request_id，等待核查；不要自行认定为未扣费。"],
  ["200 + failed", "请求已返回，但任务未成功", "同时检查 status、error、工具输出项和 billing。"],
  ["断线 / 超时", "无法确定最终结果", "任务可能仍在执行；保留原幂等键及 request_id，不换新键自动重试。"],
];
